import { render } from "./StepsTabs.vue?vue&type=template&id=445b5bed"
import script from "./StepsTabs.vue?vue&type=script&lang=js"
export * from "./StepsTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__